// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PurchasedItem/style.css
// module id = 2023
// module chunks = 0